// @flow
import { getOrigin } from '../utils';
import { DELETE, POST } from './questions-connect-micros';

const MICROS_URL = getOrigin();
const CONTENT_ADDON_URL = `${MICROS_URL}/rest/questions-connect/1.0/content`;

export const deleteAnswer = (answerId: string, questionId: string) => {
	return DELETE(`${CONTENT_ADDON_URL}/question/${questionId}/answer/${answerId}`, {});
};

export const postQuestion = (
	spaceKey: string,
	title: string,
	body: string,
	labels: Array<string>,
) => {
	const payload = {
		spaceKey,
		title,
		contentBody: {
			body: JSON.stringify(body),
			representation: 'atlas_doc_format',
		},
		labels,
	};
	return POST(`${CONTENT_ADDON_URL}/question`, JSON.stringify(payload), {
		'Content-Type': 'application/json',
	}).then((result) => result.json());
};

export const postAnswer = (title: string, body: string, parentId: string, spaceKey: string) => {
	const payload = {
		spaceKey,
		title,
		contentBody: {
			body: JSON.stringify(body),
			representation: 'atlas_doc_format',
		},
	};
	return POST(`${CONTENT_ADDON_URL}/question/${parentId}/answer`, JSON.stringify(payload), {
		'Content-Type': 'application/json',
	}).then((result) => result.json());
};
